import { Table } from "antd";
import type { HelpStatus } from "./chatTypes";

export function HelpNoticeDetails({ status }: { status?: HelpStatus }) {
  return <><p>{status?.notice}</p>
    <Table scroll={{ x: "max-content" }} size="small" pagination={false} rowKey="item" dataSource={status?.disclosure?.sending ?? []}
      columns={[{ title: "送るもの", width: 240, dataIndex: "item" }, { title: "内容", width: 320, ellipsis: true, dataIndex: "content" }, { title: "送らないもの", width: 320, ellipsis: true, dataIndex: "excluded" }]} />
    <Table scroll={{ x: "max-content" }} size="small" pagination={false} rowKey="item" dataSource={status?.disclosure?.retention ?? []}
      columns={[{ title: "場所", width: 240, dataIndex: "item" }, { title: "残るもの", width: 320, ellipsis: true, dataIndex: "content" }, { title: "期間", width: 240, dataIndex: "period" }]} />
    <p>{status?.retention_notice}</p></>;
}
